import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { UiSharedModule } from 'ui-shared';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { TranslateModule } from '@ngx-translate/core';
import { PersonnelPickerModule } from '../personnel-picker/personnel-picker.module';
import { PersonnelListViewerPageComponent } from './component/personnel-list-viewer-page.component';
import {HrPerPersonnelSearchModule}  from '../personnel-operations/component/hr-per-personnel-search/hr-per-personnel-search.module'

@NgModule({
    declarations: [PersonnelListViewerPageComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TranslateModule,
        HvlFormItemModule,
        MenuModule,
        TableModule,
        PersonnelPickerModule,
        HrPerPersonnelSearchModule,
    ],
    exports: [PersonnelListViewerPageComponent],
})
export class PersonnelListViewerModule {}
